import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { formatDate, getClassNames } from '../../../../utils/util';
import { ACTIVE_LISTING } from '../../../../utils/constants';

import Image from '../../../common/image/Image';
import Button from '../../../common/button/Button';
import ImageCarousel from '../../../common/image-carousel/ImageCarousel';
import Tooltip from '../../../common/tooltip/ToolTip';

import { ReactComponent as Bookmarked } from '../../../../resources/icons/star-filled.svg';
import { ReactComponent as UnBookmarked } from '../../../../resources/icons/star-empty.svg';
import { ReactComponent as ShareIcon } from '../../../../resources/icons/share.svg';

import './product-listing-page.scss';

const ProductListingPage = ({
  productListing,
  updateBookmark,
  bookmarked,
  expressInterest,
  isCreator,
  buzzProduct,
  currencyCode,
}) => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(undefined);

  const navigate = useNavigate();

  const renderImages = (images) => {
    if (!images) return;

    return images.map((image, index) => {
      return (
        <div key={index} className="product-listing-page__photo" onClick={() => setSelectedImageIndex(index)}>
          <Image externalReference={image} alt="" />
        </div>
      );
    });
  };

  const renderButtons = () => {
    if (isCreator) {
      return (
        <>
          <Button onClick={() => navigate(`/shop/upload-product-listing/${productListing.productExternalReference}`)}>
            Edit Listing
          </Button>
          {productListing.status === ACTIVE_LISTING && (
            <div className="product-listing-page__buzz-container">
              <Button onClick={() => buzzProduct(productListing)}>
                Buzz This
                <ShareIcon />
              </Button>
              <div className="product-listing-page__tooltip">
                <Tooltip text="Promote your Product Listing on the Market Buzz." maxWidth={400} toolTipLeft={true} />
              </div>
            </div>
          )}
        </>
      );
    }

    return (
      <>
        <div className="product-listing-page__bookmark" onClick={() => updateBookmark()}>
          <h1>Bookmark This</h1>
          {bookmarked ? <Bookmarked /> : <UnBookmarked />}
        </div>
        <Button onClick={expressInterest}>Let's Negotiate</Button>
      </>
    );
  };

  return (
    <>
      <section className="product-listing-page">
        <section className="product-listing-page__back">
          <h1>Product Listing</h1>
          <div className="product-listing-page__back-button" onClick={() => navigate(-1)}>
            <h1>{'< '}Back</h1>
          </div>
        </section>
        <section className="product-listing-page__container">
          <section className="product-listing-page__product">
            <h1>{productListing?.brandName}</h1>
            <div className="product-listing__details__classification">
              <p>{productListing?.classification?.name}</p>
              <div>
                <p>{productListing?.category?.name}</p>
                <div>
                  <p>{productListing?.specification?.name}</p>
                </div>
              </div>
            </div>
            <div className="product-listing-page__product_unit">
              <h1>Product Unit:</h1>
              <h2>{productListing?.productUnit}</h2>
            </div>
            <div className="product-listing-page__total-product">
              <h1>Total Amount of Product:</h1>
              <h2>{productListing?.totalAmount}</h2>
            </div>
            <div className="product-listing-page__available-from">
              <h1>Offer available from:</h1>
              <h2>{formatDate(productListing?.offerAvailableFrom)}</h2>
            </div>
            <div className="product-listing-page__city">
              <h1>Location City:</h1>
              <h2>{productListing?.city}</h2>
            </div>
            <div className="product-listing-page__photos">
              <h1>Photos:</h1>
              <div>{renderImages(productListing?.linkedMediaExternalReferences)}</div>
            </div>
            <div className="product-listing-page__city">
              <h1>Additional Information:</h1>
              <h2>{productListing?.additionalInformation}</h2>
            </div>
          </section>
          <section className="product-listing-page__product">
            <div className="product-listing-page__status">
              <h1>Status</h1>
              <h2>{productListing?.status}</h2>
            </div>
            <div className="product-listing-page__creation">
              <h1>Creation Date</h1>
              <h2>{formatDate(productListing?.creationDate)}</h2>
            </div>
            <div className="product-listing-page__price">
              <h1>Price per Product Unit:</h1>
              <h2>{currencyCode + ' ' + parseFloat(productListing?.pricePerProductUnit).toFixed(2)}</h2>
            </div>
            <div className="product-listing-page__minimum">
              <h1>Minimum Order Quantity:</h1>
              <h2>{productListing?.minimumOrderQuantity}</h2>
            </div>
            <div className="product-listing-page__minimum">
              <h1>Offer expires on:</h1>
              <h2>{formatDate(productListing?.offerExpiresOn)}</h2>
            </div>
            <div className="product-listing-page__city">
              <h1>Location Country:</h1>
              <h2>{productListing?.country}</h2>
            </div>
            <div className={getClassNames('product-listing-page__buttons', { creator: isCreator })}>
              {renderButtons()}
            </div>
          </section>
        </section>
      </section>

      {selectedImageIndex !== undefined && (
        <ImageCarousel
          images={productListing?.linkedMediaExternalReferences}
          startIndex={selectedImageIndex}
          setStartIndex={setSelectedImageIndex}
        />
      )}
    </>
  );
};

ProductListingPage.propTypes = {
  productListing: PropTypes.shape({}),
  updateBookmark: PropTypes.func.isRequired,
  bookmarked: PropTypes.bool,
  expressInterest: PropTypes.func.isRequired,
  isCreator: PropTypes.bool,
  buzzProduct: PropTypes.func.isRequired,
  currencyCode: PropTypes.string.isRequired,
};

ProductListingPage.defaultProps = {
  bookmarked: false,
  productListing: undefined,
  isCreator: false,
};

export default ProductListingPage;
